export default {
      id: "qrcode-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#qrcode",
      toString: function () {
        return this.url;
      }
    }